import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
@Injectable()
export class AccountModificationsService {
  constructor(private http: HttpClientService) {}

  public postCreate(modifications): Observable<any> {
    let options = {
      account_modifications: modifications,
    };
    return this.http
      .post("/api/account_modifications", options)
      .pipe(tap((_) => console.log("AccountModificationsService.create: Ok.")));
  }
  public getUnverified(filters): Observable<any> {
    const options = {
      params: filters,
    };
    return this.http
      .get("/api/account_modifications/unverified", options)
      .pipe(tap((_) => console.log("AccountModificationsService.getUnverified: Ok.")));
  }
  public getUnverifiedCount(): Observable<any> {
    return this.http
      .get("/api/account_modifications/unverified_count")
      .pipe(tap((_) => console.log("AccountModificationsService.getUnverifiedCount: Ok.")));
  }

  public postApprove(id): Observable<any> {
    return this.http
      .post("/api/account_modifications/" + id + "/approve", {})
      .pipe(tap((_) => console.log("AccountModificationsService.postApprove: Ok.")));
  }
  public postReject(id): Observable<any> {
    return this.http
      .post("/api/account_modifications/" + id + "/reject", {})
      .pipe(tap((_) => console.log("AccountModificationsService.postReject: Ok.")));
  }
}
